import styled from 'styled-components';

export const InputCodeContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
`;

export const InputCodeItem = styled.input`
  width: 62px;
  height: 62px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  text-align: center;
  font-size: 16px;
  font-weight: 600;
  color: #000;
  background-color: #f0f0f0;
`;
